/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Teamcta1Inputs */

const zh_pricing_teamcta1 = /** @type {(inputs: Pricing_Teamcta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始使用`)
};

const en_pricing_teamcta1 = /** @type {(inputs: Pricing_Teamcta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const es_pricing_teamcta1 = /** @type {(inputs: Pricing_Teamcta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Pricing_Teamcta1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_teamcta1 = /** @type {((inputs?: Pricing_Teamcta1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Teamcta1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_teamcta1(inputs)
	if (locale === "en") return en_pricing_teamcta1(inputs)
	return es_pricing_teamcta1(inputs)
});
export { pricing_teamcta1 as "pricing_teamCta" }